import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_MOBILE_APP_IOS_MWEB_DOWNLOAD_BANNER_V2 = defineFcm('mobile_app_ios_mweb_download_banner_v2')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				traffic_percentage: { type: 'number' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-mobile',
		scope: 'corgi-front-end',
		context: 'Starter Dashboard and Starter Petition Page',
		description: 'Controls the rollout of the V2 mobile app download CTA bottom banner for iOS devices on mobile web.',
		import: false,
		template: {
			traffic_percentage: 0,
		},
	});
